const firebaseConfig = {
    apiKey: "AIzaSyBktiM9yimnSfLO-egsCse1ceOoAI8VaZU",
    authDomain: "handhygieneaudit-4ee40.firebaseapp.com",
    databaseURL: "https://handhygieneaudit-4ee40.firebaseio.com",
    projectId: "handhygieneaudit-4ee40",
    storageBucket: "handhygieneaudit-4ee40.appspot.com",
    messagingSenderId: "651029523652"
}

export { firebaseConfig }


// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js